

























import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';

@Component
export default class TransportVouchersOverview extends Mixins(OverviewMixin) {
  public tableCfg = FieldDefs;
  public eventFieldName = this.getTableCfg(this.tableCfg, 'lastEventFieldName');
  public eventMap = this.getTableCfg(this.tableCfg, 'eventMap');

}
